import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const KickoffIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M6 1a1 1 0 0 0-1 1v1h-.5a3.5 3.5 0 1 0 0 7h.57A7 7 0 0 0 9 15.32V17l-.05.08a1.1 1.1 0 0 1-.34.23A4.8 4.8 0 0 0 6.08 21H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2h-2.08a4.8 4.8 0 0 0-2.53-3.7 1.05 1.05 0 0 1-.34-.23.26.26 0 0 1-.05-.08v-1.67A7 7 0 0 0 18.93 10h.57a3.5 3.5 0 0 0 0-7H19V2a1 1 0 0 0-1-1H6Zm13 4v3h.5a1.5 1.5 0 0 0 0-3H19Zm-6 10.93a6.99 6.99 0 0 1-2 0V17c0 1.15-.94 1.84-1.55 2.12-.56.25-1.1.92-1.33 1.88h7.76c-.23-.96-.77-1.63-1.33-1.88-.61-.28-1.55-.97-1.55-2.12v-1.07ZM5 8V5h-.5a1.5 1.5 0 0 0 0 3H5Zm2 1V3h10v6A5 5 0 1 1 7 9Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default KickoffIcon;
